interface Wareki {
  gannenYear: number;
  nengou: string;
  english: string;
}

export function getBrowserLocale() {
  const brLocale = window.navigator.language;
  let dtLocale = brLocale;
  if (dtLocale === 'ja' || dtLocale === 'ja-JP') {
   dtLocale = 'ja';
  }
 return dtLocale;
}


export function trasformToDate(dateStr: string, useLocale: string) {
  if (getBrowserLocale() === 'ja' || useLocale === 'ja') {
    return transformToJapaneseDate(dateStr);
  }
}

function changeDate (dateStr: string): string {
  const date = new Date(dateStr);
  const year: any = date.getFullYear();
  let month: any = date.getMonth() + 1;
  let day: any = date.getDate();
  if (month < 10) {
    month = '0' + month;
  }
  if (day < 10) {
    day = '0' + day;
  }
  return year + '/' + month + '/' + day;
}

function transformToJapaneseDate(dateStr: string): string {

    const yearArr: Wareki[] = [
      // { gannenYear: 2019, nengou: '○○', english: '○○' },
      { gannenYear: 1989, nengou: '平成', english: 'HEISEI' },
      { gannenYear: 1926, nengou: '昭和', english: 'SHOWA' },
      { gannenYear: 1912, nengou: '大正', english: 'TAISHO' },
      { gannenYear: 1868, nengou: '明治', english: 'MEIJI' },
      { gannenYear: 1912, nengou: 'D', english: 'D' },
      { gannenYear: 2019, nengou: '令和', english: 'REIWA' }
    ];

    const pattern = /(^[a-zA-Z]+)([0-9]+).?([0-9]*).?([0-9]*)/;
    const seirekiPattern = /[0-9]{6,8}/;
    if (pattern.test(dateStr)) {
      const matcherGroup = dateStr.match(pattern);
      const nengou = matcherGroup[1];
      let yearNum = Number.parseInt(matcherGroup[2] , 10);
      let month = matcherGroup[3];
      let day = matcherGroup[4];
      if (matcherGroup[2].length === 5 || matcherGroup[2].length === 6) {
        yearNum = Number.parseInt(matcherGroup[2].substring(0, matcherGroup[2].length - 4), 10);
        month = matcherGroup[2].substring(matcherGroup[2].length - 4, matcherGroup[2].length - 2);
        day = matcherGroup[2].substring(matcherGroup[2].length - 2);
      }

      let seirekiYear = 0;
      for (const year of yearArr) {
        if (year.english.startsWith(nengou.toUpperCase())) {
          seirekiYear = year.gannenYear + yearNum - 1;
          break;
        }
      }
     if (seirekiYear !== 0) { 
      month = month === '' ? '1' : month;
      day = day === '' ? '1' : day;
      dateStr = seirekiYear.toString() + '/' + month + '/' + day;
     }
    } else if (seirekiPattern.test(dateStr)) {
      const year = dateStr.substring(0, 4);
      let month = '';
      let day = '';
      if (dateStr.length === 8) {
        month = dateStr.substring(4, 6);
        day = dateStr.substring(6);
      } else if (dateStr.length === 7) {
        if (Number.parseInt(dateStr.substring(4, 6), 10) > 12) {
          month = dateStr.substring(4, 5);
          day = dateStr.substring(5);
        } else {
          month = dateStr.substring(4, 6);
          day = dateStr.substring(6);
        }
      } else {
        month = dateStr.substring(4, 5);
        day = dateStr.substring(5);
      }
      dateStr = year + '/' + month + '/' + day;
    }
    dateStr = changeDate(dateStr);
    return dateStr;
  }

